"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error]", error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          margin: 0,
          fontFamily:
            "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
          background: "#0a0c10",
          color: "#f5f5f4",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
      >
        <div style={{ maxWidth: 480, textAlign: "center" }}>
          <div
            style={{
              width: 64,
              height: 64,
              margin: "0 auto 24px",
              borderRadius: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(239, 68, 68, 0.15)",
              color: "#ef4444",
              fontSize: 32,
              fontWeight: 800,
            }}
          >
            !
          </div>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 800,
              letterSpacing: "-0.02em",
              margin: 0,
            }}
          >
            Erro crítico
          </h1>
          <p
            style={{
              marginTop: 8,
              fontSize: 14,
              color: "#b3b8c2",
              lineHeight: 1.5,
            }}
          >
            Algo deu muito errado e não conseguimos recuperar. Tente novamente.
          </p>
          {error.digest && (
            <p
              style={{
                marginTop: 8,
                fontFamily: "ui-monospace, monospace",
                fontSize: 11,
                color: "#6b7280",
              }}
            >
              ID: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: 24,
              padding: "10px 20px",
              fontSize: 14,
              fontWeight: 600,
              color: "#ffffff",
              background:
                "linear-gradient(135deg, #ff8c4a 0%, #ff6b1a 50%, #e85a0d 100%)",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(255, 107, 26, 0.3)",
            }}
          >
            Tentar novamente
          </button>
        </div>
      </body>
    </html>
  );
}
